import { Button } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState, useRef, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";


const PatientAppointmentBooking = () => {
  const buttonRefs = [useRef(null), useRef(null), useRef(null)];

  const stepTexts = [
    "This is button 1",
    "This is button 2",
    "This is button 3",
  ];

    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const totalSteps = stepTexts.length;

  const [step, setStep] = useState(0);
  const [spotlightStyle, setSpotlightStyle] = useState({});

  const updateSpotlight = () => {
    const target = buttonRefs[step]?.current;
    if (!target) return;

    const rect = target.getBoundingClientRect();

    setSpotlightStyle({
      top: rect.top - 10,
      left: rect.left - 10,
      width: rect.width + 20,
      height: rect.height + 20,
    });
  };

  useEffect(() => {
    updateSpotlight();

    window.addEventListener("resize", updateSpotlight);
    window.addEventListener("scroll", updateSpotlight, true);

    const resizeObserver = new ResizeObserver(updateSpotlight);
    resizeObserver.observe(document.body);

    return () => {
      window.removeEventListener("resize", updateSpotlight);
      window.removeEventListener("scroll", updateSpotlight, true);
      resizeObserver.disconnect();
    };
  }, [step]);

  return (
    <div>
      {/* ---------- Overlay ---------- */}
      {step < totalSteps && (
        <div
        onClick={() => {
            if (isSmall) setStep((prev) => prev + 1);
        }}
        style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            pointerEvents: "auto",
        }}
        >

          {/* Highlight box */}
          <div
            style={{
              position: "fixed",
              borderRadius: "12px",
              border: "2px solid white",
              boxShadow: "0 0 0 9999px rgba(0,0,0,0.6)",
              pointerEvents: "none",
              transition: "none", // instant snapping
              ...spotlightStyle,
            }}
          />

          {/* ---------- Text Bubble ---------- */}
          <div
            style={{
              position: "fixed",
              top: spotlightStyle.top + spotlightStyle.height + 20,
              left: spotlightStyle.left,
              background: "white",
              padding: "12px 16px",
              borderRadius: "8px",
              maxWidth: "260px",
              fontSize: "15px",
              color: "#333",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            {stepTexts[step]}
          </div>

            {/* ---------- Step Counter + Navigation (responsive) ---------- */}
            <div
            style={{
                position: "fixed",
                bottom: "40px",
                width: "100%",
                textAlign: "center",
                color: "white",
            }}
            >
            {/* Step counter */}
            <div style={{ marginBottom: "10px", fontSize: "16px" }}>
                Step {step + 1} of {totalSteps}
            </div>

            {/* If small screen → Tap anywhere */}
            {isSmall ? (
                <div style={{ fontSize: "17px", opacity: 0.9 }}>
                Tap to continue
                </div>
            ) : (
                // If medium/large → Show Next button
                <Button
                variant="contained"
                onClick={() => setStep((prev) => prev + 1)}
                >
                Next
                </Button>
            )}
            </div>

        </div>
      )}

      {/* ---------- Original UI ---------- */}
      <Box
        sx={{
          width: "100%",
          padding: "30px 0",
          textAlign: "center",
        }}
      >
        <Stack
          direction="column"
          justifyContent="center"
          spacing={2}
          maxWidth="200px"
          margin="auto"
        >
          <Button variant="contained" ref={buttonRefs[0]}>
            I am testing 1
          </Button>
          <Button variant="contained" ref={buttonRefs[1]}>
            I am testing 2
          </Button>
          <Button variant="contained" ref={buttonRefs[2]}>
            I am testing 3
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default PatientAppointmentBooking;
